import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  getLocalStorageObject,
  setLocalStorageObject,
} from "../../../util/helper";
import { Grid, Typography } from "@material-ui/core";
import { Radio, InputNumber, Switch } from "antd";
import { ConsoleView } from "react-device-detect";
import { Card, Form, Button } from "react-bootstrap";
import PlusMinQty from "../../utilities/PlusMinQty";
import UseDebounce from "../../common/useDebounce";
import CheckboxDropdown from "../positionPage/position-comp/dropdownWithCheckbox";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";
let localStorageObj = getLocalStorageObject("global") || {
  strikeValue: 10,
  isQT: false,
};

const defAtm = ["Spot", "Futures", "SynFut"];
const defHedge = ["Premium", "Distance", "Delta"];

const OptionChainTabs = ({
  isPosition,
  setisPosition,
  isSellFirst,
  setisSellFirst,
  isSynFut,
  setisSynFut,
  info,
  columns,
  setColumns,
  hedgeVal,
  sethedgeVal,
  hedge,
  sethedge,
  atmVal,
  setatmVal,
  setSelectStrikes,
  selectStrikes,
  isQT,
  setisQT,
  optType,
  setOptType,
  isStraddle,
  setStraddle,
  type,
}) => {
  const defaultStrike = 10;
  const timeoutRef = useRef();
  const strikeVal = useRef("10");
  const [hedgeRef, sethedgeRef] = useState(0);
  const debounceValue = UseDebounce(hedgeRef, 1000);
  const suscriptionStatus = useSelector(
    (state) => state?.packages?.suscriptionStatus
  );

  const [isModify, setisModify] = useState("");

  useEffect(() => {
    if (type != "futures" && type != "CustomOption") {
      sethedgeVal(debounceValue);
    }
    //if(debounceValue) {

    // }
  }, [debounceValue]);
  // connecting to socket data

  const callStrikeChange = () => {
    setLocalStorageObject(
      "global",
      "strikeValue",
      parseInt(strikeVal.current),
      localStorageObj
    );
    setSelectStrikes(parseInt(strikeVal.current));

    timeoutRef.current = undefined;
  };

  const onSelectStrike = (value) => {
    strikeVal.current = value;

    if (!timeoutRef.current) {
      const myTimeout = setTimeout(callStrikeChange, 1000);
      timeoutRef.current = myTimeout;
    }
  };

  const changeAtm = (val) => {
    setatmVal(val);
    setLocalStorageObject("global", "atm", val, localStorageObj);
  };
  const changeHedge = (val) => {
    sethedge(val);
    setLocalStorageObject("global", "hedge", val, localStorageObj);
    //sethedgeRef(0);
    sethedgeVal(0);
  };

  const clearfiled = (type) => {
    sethedgeVal(0);
  };
  const handleCellHover = (type) => {
    setisModify(type);
  };
  const handleCellHoverLeave = (type) => {
    setisModify("");
  };
  return (
    <div className="mb-1">
      <div
        style={{ gap: "6px", paddingBottom: "4px", paddingInline: "4px" }}
        className="d-flex align-items-center flex-wrap"
      >
        {type != "futures" && type != "CustomOption" && (
          <>
            <Grid style={{ paddingBlock: "5px" }} item className="order-window-body">
              <Form.Select
                style={{ width: "85px" }}
                className="opt-chn-select"
                aria-label="Default select ATM"
                name="atmVal"
                value={atmVal}
                onChange={(e) => changeAtm(e.target.value)}
              >
                {defAtm.map((data, index) => {
                  return (
                    <option value={data} key={index}>
                      {data}
                    </option>
                  );
                })}
              </Form.Select>
            </Grid>
            <>
              <Grid style={{ paddingBlock: "5px" }} item className="order-window-body">
                <Form.Select
                  style={{ width: "85px" }}
                  className="opt-chn-select"
                  aria-label="Default select Hedge"
                  name="hedge"
                  value={hedge}
                  onChange={(e) => changeHedge(e.target.value)}
                >
                  {defHedge.map((data, index) => {
                    return (
                      <option value={data} key={index}>
                        {data}
                      </option>
                    );
                  })}
                </Form.Select>
              </Grid>
              <Grid
                item
                style={{ paddingBlock: "5px" }}
                className="order-window-body d-flex input-PM-op"
                onMouseLeave={(e) => handleCellHoverLeave("Hedge")}
                onMouseEnter={(e) => handleCellHover("Hedge")}
              >
                <PlusMinQty
                  qtyClick={(qty, value) => {
                    sethedgeRef(parseFloat(qty));
                  }}
                  filterValue={hedgeVal}
                  min={null}
                  step={null}
                  max={null}
                  page={"op"}
                  isModify={isModify}
                />
                {/* <img
                        src={shape1}
                        alt="delete"
                        onClick={()=>clearfiled("hedge")}
                        className="cross-img"
                      />  */}
                <div className="cross-icon" onClick={() => clearfiled("hedge")}>
                  <ClearIcon fontSize="small" className="cross-img" />
                </div>
              </Grid>
            </>
          </>
        )}
        {type != "futures" && type != "CustomOption" && (
          <Grid item className="d-flex checkBoxSelectionOP">
            <CheckboxDropdown
              items={columns}
              setColumns={setColumns}
              disabledColum={["lpCE", "posCE", "strike", "posPE", "lpPE"]}
              hideColum={[
                "oiPE",
                "oiChgPE",
                "deltaPE",
                "lpCE",
                "strike",
                "lpPE",
              ]}
            />
          </Grid>
        )}
        {type !== "CustomOption" && type !== "futures" && (
          <Grid
            item
            style={{ paddingBlock: "5px" }}
            onMouseLeave={(e) => handleCellHoverLeave("strike")}
            onMouseEnter={(e) => handleCellHover("strike")}
            className="input-PM-op order-window-body"
          >
            <PlusMinQty
              qtyClick={(qty, value) => {
                onSelectStrike(qty);
              }}
              filterValue={selectStrikes}
              min={1}
              step={1}
              page={"op"}
              isModify={isModify}
            />
          </Grid>
        )}

        {type !== "CustomOption" && (
          <>
            <div style={{ paddingBlock: "5px", marginRight: "4px" }} className="group-sq- d-flex align-items-center">
              <Switch
                size="small"
                checked={isQT}
                onChange={(checked) => {
                  setisQT(checked);
                  setLocalStorageObject(
                    "global",
                    "isQT",
                    checked,
                    localStorageObj
                  );
                }}
                style={{ marginRight: 6 }}
              />
              <span style={{ fontSize: 12 }}>QuikTrade</span>
            </div>
            <div style={{ paddingBlock: "5px", marginRight: "4px" }} className="group-sq- d-flex align-items-center">
              <Switch
                size="small"
                checked={isSellFirst}
                onChange={(checked) => {
                  setisSellFirst(checked);
                  setLocalStorageObject(
                    "global",
                    "isSellFirst",
                    checked,
                    localStorageObj
                  );
                }}
                style={{ marginRight: 6 }}
              />
              <span style={{ fontSize: 12 }}>Sell First</span>
            </div>
          </>
        )}

        {type === "basket" && (
          <div style={{ paddingBlock: "5px", marginRight: "4px" }} className="group-sq- d-flex align-items-center">
            <Switch
              size="small"
              checked={isStraddle}
              onChange={(checked) => {
                setStraddle(checked);
              }}
              style={{ marginRight: 6 }}
            />
            <span style={{ fontSize: 12 }}>Straddle</span>
          </div>
        )}
        {type === "basket" && (
          <div style={{ paddingBlock: "5px" }} className="group-sq- pos d-flex align-items-center">
            <Switch
              size="small"
              checked={isPosition}
              onChange={(checked) => {
                setisPosition(checked);
              }}
              style={{ marginRight: 6 }}
            />
            <span style={{ fontSize: 12 }}>Positions</span>
          </div>
        )}
        {type === "basket" && (
          <div style={{ paddingBlock: "5px" }} className="group-sq- pos d-flex align-items-center">
            <Switch
              size="small"
              checked={isSynFut}
              onChange={(checked) => {
                setisSynFut(checked);
                setLocalStorageObject(
                  "global",
                  "isSynFut",
                  checked,
                  localStorageObj
                );
              }}
              style={{ marginRight: 6 }}
            />
            <span style={{ fontSize: 12 }}>Syn Fut</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OptionChainTabs;
